var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.282 30.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fdecef;}.cls-2{fill:#ed6a72;stroke:#ec6a72;stroke-miterlimit:10;stroke-width:0.5px;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TEXT_GENERATOR",
    "data-name": "TEXT GENERATOR"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.141,
    cy: 15.141,
    r: 15.141
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.094,14.636a5.552,5.552,0,1,1,5.552,5.552A5.551,5.551,0,0,1,10.094,14.636Zm1.009,0a4.543,4.543,0,1,0,4.543-4.542A4.542,4.542,0,0,0,11.1,14.636Zm5.7,1.871-1.514-1.514a.5.5,0,0,1-.148-.357V11.608a.5.5,0,1,1,1.009,0v2.819l1.366,1.366a.5.5,0,1,1-.713.714Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoric);
export default __webpack_public_path__ + "static/media/historic.46f05be36db31012ad147d1cfc12c52b.svg";
export { ForwardRef as ReactComponent };